import StyledSelect from '@/components/StyledInputFields/StyledSelect.tsx';
import { InputSource } from '@/types/automationFields.ts';

type props = {
  label: string;
  value: InputSource;
  onChange: (updated_value: InputSource) => void;
  allowBoth?: boolean;
};

type optionsType = {
  label: string;
  value: InputSource;
};

const USER_SPECIFIED_OPTION = { label: 'User specified', value: InputSource.UserSpecified };
const FROM_DATASET_OPTION = { label: 'From input dataset', value: InputSource.FromDataset };
const BOTH_OPTION = { label: 'User specified and from input dataset', value: InputSource.Both };

const ALL_OPTIONS: optionsType[] = [USER_SPECIFIED_OPTION, FROM_DATASET_OPTION, BOTH_OPTION];

const NO_BOTH_OPTIONS: optionsType[] = [USER_SPECIFIED_OPTION, FROM_DATASET_OPTION];

const InputSourceSelectField = ({ label, value, onChange, allowBoth = true }: props) => {
  return (
    <StyledSelect
      label={label}
      data={allowBoth ? ALL_OPTIONS : NO_BOTH_OPTIONS}
      value={value}
      onChange={(v) => onChange(v as InputSource)}
      required={true}
      allowDeselect={false}
      clearable={false}
    />
  );
};

export default InputSourceSelectField;
